import {SpriteCollector} from "./SpriteCollector";
import {TheCrypt} from "../../TheCrypt";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {TimelineLite} from "gsap";
import {TheCryptSoundManager} from "../../sound/TheCryptSoundManager";

export class M1Collector extends SpriteCollector {

    constructor(id:number, container:PIXI.Container) {
        super(id, container);
    }

    public set overlayText(value:number) {
        this._overlay.text = `X${value}`;
        this._overlay.position.x = -this._overlay.width * 0.5;
        if(TheCrypt.model.data.m1NextMultiplier < 0) {
            debugger
            throw Error;
        }
        this._overlay.letterSpacing = value === 1 ? 8 : 2;
        this._overlay.visible = true;
        this._overlay.alpha = 1;
        this.addChild(this._overlay);
    }

    public resetProgress() {
        //this._step = 0;
        //this._spine!.state.setAnimation(0, "base", false);
    }

    public upgrade():TimelineLite {
        this._step++;
        return new TimelineLite().add([
            new SpineTween(this._spine!, 1, "upgrade"),
            () => {
                TheCryptSoundManager.playSound("fsMultiCollect");
            }
        ]);
    }

    public show(name:string, isRestore:boolean = false):TimelineLite {
        const tl:TimelineLite = super.show(name, isRestore);
        this._step = 0;
        this.isActive = true;
        if(isRestore && !TheCrypt.model.isNormal) {
            this._step = TheCrypt.model.sideBarProgress[6 - this._id];
            this._step = Math.max(-1, this._step);
            //    animationName = (this._step > -1 ? this._step.toString() : animationName);
        }
        tl.add([
            () => {
                this.addChild(this._spine!);
                this.overlayText = TheCrypt.model.data.m1NextMultiplier;
                this._spine!.state.setAnimation(0, "base", true);
            }
        ]);
        return tl;
    }

    public fullyCharged():SpineTween {
        //if ((NolimitConfig.isDevMode) && (this._step != this._barNum)) {
        //    debugger;
        //}
        this.overlayText = TheCrypt.model.data.m1NextMultiplier;
        TheCryptSoundManager.playSound("fsMultiUp");
        this.resetProgress();
        return new SpineTween(this._spine!, 1, "upgrade");
    }

    get isFullyCharged():boolean {
        if(TheCrypt.model.data.m1NextMultiplier < 2) {
            return false;
        }

        const M1CurrentMultiplier:string = this._overlay.text;
        if(!M1CurrentMultiplier) {
            return true;
        }

        const multiplier:number = parseInt(M1CurrentMultiplier.slice(1));
        return TheCrypt.model.data.m1NextMultiplier > multiplier;
    }
}